// extracted by mini-css-extract-plugin
export default {"container":"EQ-z","topReviewHeading":"FQ-z","criticalReview":"GQ-z","favorableReview":"HQ-z","vsSeparator":"IQ-z"};